import { useGomakeTheme } from "@/hooks/use-gomake-thme";
import { FONT_FAMILY } from "@/utils/font-family";
import { useMemo } from "react";

const useStyle = () => {
  const { theme, primaryColor } = useGomakeTheme();
  const classes = useMemo(() => {
    return {
      container: {
        backgroundColor: "#FFFFFF",
        flex: 1,
        display: "flex",
        flexDirection: "row" as "row",
        alignItems: "center",
        justifyContent: "center" as "center",
        height: "100vh",
        // ...FONT_FAMILY.Lexend(600),
      },
    };
  }, [theme]);
  return {
    classes,
  };
};
export { useStyle };
